import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { PropConfig } from '../../types/EntityConfig';




export function EnhancedTableHead({ onRequestSort, headCells}: { onRequestSort : Function, headCells: any}) {
    
  const createSortHandler = (property : any) => (event : any) => {
      onRequestSort(event, property);

    };
  
    return (
      <>

      <TableHead className="flex bg-rodrimaq-red-light z-20">

        <TableRow >
          <TableCell/>

          {headCells.filter((hc: any)=>!hc.hidden).filter((tc: PropConfig) => !tc.hideColumn).map((headCell : any, idx : number) => (
            <TableCell
              key={`${headCell.id}-${idx}`}
              align={'left'}
              padding={'none'}
              className="h-14"
              // sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                // active={orderBy === headCell.id}
                // direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
               
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      </>
    );
  }
  
 

  // {orderBy === headCell.id ? (
  //   <Box component="span" sx={visuallyHidden}>
  //     {/* {order === 'desc' ? 'sorted descending' : 'sorted ascending'} */}
  //   </Box>
  // ) : null}
  